import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Segment
} from 'semantic-ui-react';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class NominaPersonasView extends Component {

  constructor (props) {
    super(props);

    this.PersonaService = this.props.feathers.service('api/personas');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(persona) => ({
            id: persona.id,
            header: `${persona.apellido}, ${persona.nombre}`,
            description: `DNI ${persona.dni}`
          })}
          service={this.PersonaService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 8],
              ['!Apellido', 'apellido', 'input', 8],
              ['!DNI', 'dni', 'input', 6]
            ],
            service: this.PersonaService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    NominaPersonasView.mapStateToProps,
    NominaPersonasView.mapDispatchToProps
  )(NominaPersonasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/personas/NominaPersonasView.js